import { CALENDAR_GRID_MINUTES_PER_ROW } from '../../../CalendarGrid.constants'
import { getCalendarGridMinuteOffset } from '../../../CalendarGrid.utils.time'

export function getCalendarGridNowStyle({ firstHour, locale, now, timezone }) {
  return {
    '--calendar-grid-now-start': String(
      getCalendarGridMinuteOffset({
        firstHour,
        locale,
        timezone,
        value: now,
      }) / CALENDAR_GRID_MINUTES_PER_ROW
    ),
  }
}
